import axios from "axios";
import { Auth } from 'aws-amplify';

require('dotenv').config();

////console.log (process.env.REACT_APP_API_URL);

const instance = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: { 'Content-Type': 'application/json',
  'Cache-Control': 'no-cache',
  'Access-Control-Allow-Headers': 'https://jobvious.app',
  'Access-Control-Allow-Origin': 'https://jobvious.app' }
});

instance.interceptors.response.use(null, error => {
  // Errors are passed through to calling code for handling
  // No global toast — let each feature decide how to display errors
  return Promise.reject(error);
});

instance.interceptors.request.use(async config =>
  {
  const user = await Auth.currentAuthenticatedUser();
  const token = user.signInUserSession.accessToken.jwtToken;

  config.headers.Authorization = token;

  return config;

}, (error) => {
  //console.log("This is the error code :", error.response.status);

  return Promise.reject(error);
});

export class HTTPService {
  // eslint-disable-next-line no-useless-constructor
  constructor () {}

  get (url, parameters = {}, config = {}) {
    if (parameters) {
      return instance.get(url, {params: parameters, ...config})
    } else {
      return instance.get(url, config)
    }
  }

  post (url, payload) {
    return instance.post(url, payload)
  }

  put (url, payload) {
    return instance.put(url, payload)
  }

  patch (url, payload) {
    return instance.patch(url, payload)
  }

  delete (url, config = {}) {
    return instance.delete(url, config)
  }
};
